<div class="container-fluid" style="padding: 0px 50px 50px 50px">
    <div class="row">
        <p *ngIf="isLoadingCorporateStructureGraph"><i class="fal fa-spinner fa-spin"></i> Loading Graph</p>
        <div class="graph-holder can-be-restricted-allow-click" *ngIf="corporateStructureGraph">
            <ngx-graph class="chart-container" [autoZoom]="true" [panOnZoom]="true"
                [enableZoom]="true" [zoomSpeed]="0.05" [minZoomLevel]="0.1" [maxZoomLevel]="2.0"
                [autoCenter]="false" [legend]="false" [links]="corporateStructureGraph.links"
                [nodes]="corporateStructureGraph.nodes" [clusters]="clusters" [curve]="curve"
                [layoutSettings]="{orientation: 'TB'}"
                layout="dagreCluster" [view]="[2000, 2000]"> <!-- could use viewport size here -->

                <ng-template #defsTemplate>
                    <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4"
                        markerHeight="4" orient="auto" fill="#fccfa0">
                        <svg:path d="M0,-5L10,0L0,5" />
                    </svg:marker>
                </ng-template>

                <ng-template #nodeTemplate let-node>
                    <svg:g class="node">
                        <svg:rect *ngIf="node.label == company.name"
                            style="stroke-width:1px; stroke: #dee2e6" [attr.width]="node.dimension.width"
                            [attr.height]="node.dimension.height" [attr.fill]="'#FA9F42'" />
                        <svg:rect *ngIf="node.label != company.name"
                            style="stroke-width:1px; stroke: #dee2e6" [attr.width]="node.dimension.width"
                            [attr.height]="node.dimension.height" [attr.fill]="'#f4f5f7'" />
                        <switch>
                            <foreignObject *ngIf="!node.link" x="0.1em" width="2em" height="1.8em">
                                <span class="flag-icon flag-icon-{{node.country_code}}"></span>
                            </foreignObject>
                            <foreignObject *ngIf="node.link" x="1.2em" width="2em" height="1.8em">
                                <span class="flag-icon flag-icon-{{node.country_code}}"></span>
                            </foreignObject>
                        </switch>
                        <svg:text *ngIf="!node.link" alignment-baseline="central" [attr.y]="10">
                            <tspan x="0.1em" dx="1.8em" dy="0.5em">{{node.label}}&nbsp;&nbsp;&nbsp;&nbsp;
                            </tspan>
                        </svg:text>
                        <svg:text *ngIf="node.link" alignment-baseline="central" [attr.x]="10"
                            [attr.y]="10">
                            <tspan x="1.2em" dx="1.8em" dy="0.5em">{{node.label}}&nbsp;&nbsp;&nbsp;&nbsp;
                            </tspan>
                            <tspan x="1.2em" dy="1.8em" *ngIf="node.cluster_id">Cluster ID: {{ node.cluster_id |
                                companyDataPipe:'Cluster ID':'' }}&nbsp;&nbsp;&nbsp;&nbsp;</tspan>
                            <tspan x="1.2em" dy="1.8em" *ngIf="node.directors"
                            ngx-tooltip
                            tooltipPlacement="top"
                            tooltipType="tooltip"
                            [tooltipTitle]="generateDirectorsList(node.directors)">Directors: {{ node.directors | slice:0:2 }}{{node.directors.length > 2 ? '...' : ''}}&nbsp;&nbsp;&nbsp;&nbsp;
                            </tspan>
                            <tspan x="1.2em" dy="1.8em" *ngIf="node.postcode">Postcode: {{ node.postcode |
                                companyDataPipe:'Postcode':'' }}&nbsp;&nbsp;&nbsp;&nbsp;</tspan>
                            <tspan x="1.2em" dy="1.8em" *ngIf="node.revenue">Revenue: {{ node.revenue |
                                companyDataPipe:'Revenue':'' }}&nbsp;&nbsp;&nbsp;&nbsp;</tspan>
                            <tspan x="1.2em" dy="1.2em" *ngIf="node.sic_code_1">{{ node.sic_code_1
                                }}&nbsp;&nbsp;&nbsp;&nbsp;</tspan>
                            <tspan x="1.2em" dy="1.2em"></tspan>
                            <a attr.xlink:href="{{node.link}}" target="_blank" *ngIf="node.link">
                                <tspan x="1.2em" dy="1.2em">View Organisation</tspan>
                            </a>
                        </svg:text>
                    </svg:g>
                </ng-template>

                <ng-template #linkTemplate let-link>
                    <svg:g class="edge" ngx-tooltip [tooltipPlacement]="'top'" [tooltipType]="'tooltip'"
                        [tooltipTitle]="link.label">
                        <svg:path class="line" [attr.stroke-width]="link.line_width" stroke="#FA9F42"
                            stroke-opacity="0.5" marker-end="url(#arrow)">
                        </svg:path>
                    </svg:g>
                </ng-template>

            </ngx-graph>
        </div>
    </div>
</div>
